import { useCallback } from "react";
import { ActiveFilter, HubViewChangeHandler } from "../common";
import { HubItemDataSource } from "client/Api/Hub/hub";

export function useOverviewSection(
	source: HubItemDataSource,
	onViewChange: HubViewChangeHandler,
	onActiveFilterChange: (activeFilter: ActiveFilter | null) => void,
	onSelectCategory: (source: HubItemDataSource, categoryId: number | null) => void
): {
		viewAllHandler: () => void;
		viewItemHandler: (id: number) => void;
		activeFilterChangeHandler: (filter: ActiveFilter | null) => void;
} {
	const viewAllHandler = useCallback(
		(): void => {
			onViewChange(
				{
					source,
					kind: "overview"
				}
			);
		},
		[source, onViewChange]
	);

	const viewItemHandler = useCallback(
		(id: number): void => {
			onViewChange(
				{
					source,
					kind: "details",
					id
				}
			);
		},
		[source, onViewChange]
	);

	const navigateToOverviewHandler = useCallback(
		(categoryId?: number | null): void => {
			onViewChange(
				{
					source,
					kind: "overview"
				}
			);

			if (categoryId !== undefined) {
				onSelectCategory(source, categoryId);
			}
		},
		[
			onSelectCategory,
			onViewChange,
			source
		]
	);

	const activeFilterChangeHandler = useCallback(
		(filter: ActiveFilter | null): void => {
			onActiveFilterChange(filter);

			if (filter !== null) {
				navigateToOverviewHandler(null);
			}
		},
		[navigateToOverviewHandler, onActiveFilterChange]
	);

	return {
		viewAllHandler,
		viewItemHandler,
		activeFilterChangeHandler
	};
}
